import { ReactNode } from "react";

export type CalloutType = "info" | "warning" | "success";

interface CalloutProps {
  type?: CalloutType;
  title?: string;
  children: ReactNode;
}

const styles: Record<CalloutType, string> = {
  info: "border-blue-500 bg-blue-50 text-blue-900",
  warning: "border-yellow-500 bg-yellow-50 text-yellow-900",
  success: "border-green-500 bg-green-50 text-green-900",
};

export default function Callout({
  type = "info",
  title,
  children,
}: CalloutProps) {
  return (
    <div className={`my-6 border-l-4 rounded-md p-4 ${styles[type]}`}>
      {title && <p className="mb-1 font-semibold">{title}</p>}
      <div className="text-sm leading-relaxed">{children}</div>
    </div>
  );
}
